'use client';

import React from 'react';
import cn from 'classnames';
import FooterLogo from './../FooterLogo';
import FooterLink from './../FooterLink';
import { INavigation } from '@framework/ui/Organisms/StickyFooter/types';
import IconLinkedIn from '@dealroadshow/uikit-icon/IconLinkedin';
import IconAngelList from '@dealroadshow/uikit-icon/IconAngelList';
import footerStyles from './../stickyFooter.module.scss';
import styles from './navigation.module.scss';

const renderNavigationLink = (item: { [key: string]: any }, i: number) => {
  if (item.itemCallback) {
    return React.createElement(item.itemCallback);
  }

  return (
    <FooterLink
      key={ i }
      path={ item.path }
      className={ item.itemClassName }
      shouldOpenInNewTab={ item.shouldOpenInNewTab }
      onClick={ item.onClick }
    >
      { item.title }
    </FooterLink>
  );
};

interface IProps {
  className?: string,
  links: INavigation[],
  logoClassName?: string,
}

const Navigation = (props: IProps) => (
  // @ts-ignore
  <div className={ cn(styles.navigation, { [props.className]: !!props.className }) }>
    <div className={ footerStyles.content }>
      <div className={ footerStyles.row }>
        <FooterLogo className={ cn(styles.logo, props.logoClassName) } />
        <div className={ styles.navigationLinks }>
          { props.links.map(renderNavigationLink) }
        </div>
        <div className={ styles.iconsContainer }>
          <FooterLink
            path="https://angel.co/company/finsight-group"
            shouldOpenInNewTab
            isOpenInNewTabIcon={ false }
          >
            <IconAngelList className={ styles.icon } />
          </FooterLink>
          <FooterLink
            path="https://www.linkedin.com/company/finsight/"
            shouldOpenInNewTab
            isOpenInNewTabIcon={ false }
          >
            <IconLinkedIn className={ styles.icon } />
          </FooterLink>
        </div>
      </div>
    </div>
  </div>
);

export default Navigation;
